<template>
  <div class="details">
    <validation-observer ref="observer" tag="form" @submit.prevent="submitForm">
      <div class="details__container">
        <div class="details__form">
          <details-form/>
        </div>

        <div class="details__summary">
          <order-summary>
            <submit-button

                text="Bestelling bevestigen"
                @stepBack="back"
            />
          </order-summary>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import OrderSummary from '../components/summary'
import DetailsForm from '../components/details-form'
import SubmitButton from '../components/submit-button'
import State from '../state'
import swal from 'sweetalert'
import { ValidationObserver } from 'vee-validate'

export default {
  components: {
    OrderSummary,
    DetailsForm,
    SubmitButton,
    ValidationObserver
  },
  data () {
    return { State: State }
  },
  methods: {
    back () {
      this.$emit('to2')
    },
    submitForm () {
      console.log(State.quote);

      this.$refs.observer.validate().then(success => {
        if (!success) {
          swal('Oops!', 'Zorg dat je alle velden correct hebt ingevuld', 'error')
          return
        }

        // eslint-disable-next-line no-unreachable
        let apiURL
        /* eslint-disable no-undef */
        if (typeof PlinqApiUrlData !== 'undefined') {
          apiURL = PlinqApiUrlData
          /* eslint-enable no-undef */
        } else {
          apiURL = process.env
        }

        const requestBody = new FormData()


        requestBody.append('action', 'plinqorderapi')
        requestBody.append(
          'order',
          JSON.stringify({
            Zoekgegevens: State.Zoekgegevens,
            selection: State.selection,
            Klantengegevens: State.Klantengegevens,
            totaalPrijs: State.total,
            incentivePrijs: State.incentivePrice,
            eenmaligePrijs: State.oneTimePrice,
            partner: State.partner,
            operator: State.operator,
            quote: State.quote,
          })
        )

        const requestData = {
          method: 'POST',
          body: requestBody
        }

        fetch(apiURL.VUE_APP_ORDER_API_URL, requestData)
          .then(response => response.text())
          .then(
            swal('Gelukt!', 'We hebben je bestelling goed ontvangen', 'success').then(() => {
              window.location.href = '/bedankt'
            })
          )
      })
        /* eslint-disable handle-callback-err */
        .catch(error => {
          swal('Oops!', 'Er ging iets mis, probeer het opnieuw', 'error')
        })
      /* eslint-enable handle-callback-err */
    }
  }
}
</script>

<style scoped lang="scss">
.details__container {
  display: flex;
}

.details__form {
  flex: 5;
}

.details__summary {
  flex: 2;

  & > * {
    position: sticky;
    top: 70px;
  }
}

@include mobile {
  .details__container {
    flex-direction: column;
  }
  .details__summary {
    order: -1;
  }
}
</style>
